/**
 * İLK KURULUMDAN SONRA: "Kasanız nerede dursun?" (kullanıcı kararı
 * 19.10.2026). Yeni kasa kurulunca kurulum ekranı kasanın KENDİ şifreli
 * ayarlarına `DEPOLAMA_SORUSU_AYARI = "bekliyor"` yazar; ana sayfanın en
 * üstünde bu soru, cevaplanana kadar durur. Bilgi kasanın içinde: profil
 * dışına hiçbir şey yazılmaz (CLAUDE.md §8).
 *
 * Cevap iki yoldan biter: "Yalnızca bu cihazda kalsın" ya da bir buluta
 * bağlanmak (depolama kurulunca soru kendiliğinden kalkar). Ayarlar ›
 * Depolama her zaman aynı seçimi sunar.
 */

import { M } from "../dil";
import { useState } from "react";
import { routeHref } from "../lib/router";
import { UyariIkonu } from "../ui/UyariIkonu";
import { useYedek } from "../yedek/YedekSaglayici";
import { DepolamaSecimi } from "./BulutYedegiKarti";
import { useDepolamaSorusu } from "./useDepolamaSorusu";
import { ImportReport } from "./ImportReport";

export { DEPOLAMA_SORUSU_AYARI } from "./useDepolamaSorusu";

export function DepolamaSorusu() {
  const y = useYedek();
  const soru = useDepolamaSorusu();
  const [rapor, setRapor] = useState<Parameters<typeof ImportReport>[0]["result"] | null>(null);

  if (y === null) return null;
  if (rapor !== null) {
    return (
      <div className="w-full p-4 pb-0">
        <ImportReport result={rapor} title={M.yedek.depolama.geriYuklemeTamam} />
      </div>
    );
  }
  if (!soru.bekliyor || y.defterBos === null) return null;

  return (
    <section className="w-full p-4 pb-0" aria-labelledby="depolama-sorusu-baslik">
      <div className="pf-card p-4">
        <h2 id="depolama-sorusu-baslik" className="text-[14px] font-semibold text-ink">
          {M.yedek.soru.baslik}
        </h2>
        <p className="mt-1 text-[12px] text-muted">{M.yedek.soru.sonradan}</p>
        <DepolamaSecimi onYuklendi={(r) => setRapor(r.sonuc)} onYalnizcaCihaz={soru.yalnizcaCihaz} />
      </div>
    </section>
  );
}

/** Uyarının adresi: Ayarlar, Depolama bölümüne kaydırılmış. */
export const DEPOLAMA_ADRESI = `${routeHref("ayarlar")}?bolum=depolama`;
const UYARI_ADI = M.yedek.soru.uyariAdi;
const NE_YAPMALI = M.yedek.soru.neYapmali;

/**
 * "KASANIZ NEREDE DURSUN?" UYARISI (kullanıcı kararı 19.10.2026): açılış
 * artık ana sayfa olmadığı için soru, cevaplanana kadar üç giriş sayfasının
 * (Varlık Dökümü, Hareketler, Hesaplar) üstünde de durur. Geniş ekranda ince
 * sarı şerit; telefonda üst çubukta yalnızca küçük sarı ünlem (adı ve ne
 * yapmalı ekran okuyucuda ve balonda). İkisi de Ayarlar › Depolama'yı açar.
 */
export function DepolamaUyarisi({ kip }: { readonly kip: "serit" | "ikon" }) {
  const soru = useDepolamaSorusu();
  if (!soru.bekliyor) return null;
  if (kip === "ikon") {
    return (
      <a
        href={DEPOLAMA_ADRESI}
        aria-label={`${UYARI_ADI}. ${NE_YAPMALI}`}
        title={`${UYARI_ADI} — ${NE_YAPMALI}`}
        className="inline-flex shrink-0 items-center p-1 text-warn"
      >
        <UyariIkonu tone="warn" />
      </a>
    );
  }
  return (
    <div role="status" className="hidden border-b border-warn-border bg-warn-soft px-4 py-1.5 text-[12px] text-warn md:block">
      {M.yedek.soru.serit(UYARI_ADI)}{" "}
      <a className="underline" href={DEPOLAMA_ADRESI}>
        {M.yedek.bant.ayarlarDepolama}
      </a>
    </div>
  );
}
